import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { VisionButtonModule } from '@core-mkt/shared/components/vision-button/vision-button.module';
import { StandAloneCtaComponent } from './stand-alone-cta/stand-alone-cta.component';

@NgModule({
  exports: [StandAloneCtaComponent],
  imports: [CommonModule, QueryParamModule, VisionButtonModule, StandAloneCtaComponent],
})
export class StandAloneCtaModule {}
